module.exports = __webpack_public_path__ + "img/bannerGreen.53193b95.jpg";